import { FC } from "react";

import { InformationItem } from "../../common";

export const UsdKYCInitialInstructions: FC = () => {
  return (
    <div className="flex flex-col gap-8">
      <InformationItem
        icon="Timer"
        title="It only takes a couple of minutes"
        description="Your documents are quickly verified by Bridge"
      />

      <InformationItem
        icon="shield"
        title="Your personal data is safe with us"
        description={
          <>
            We only store the information necessary for our operations. Our{" "}
            <a
              className="font-semibold text-purple-500"
              href="https://archway.finance/license"
              target="_blank"
              rel="noreferrer"
            >
              EU license
            </a>{" "}
            ensures your data's safety
          </>
        }
      />
    </div>
  );
};
